import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex w-full" }
const _hoisted_2 = { class: "h-full w-1/2" }
const _hoisted_3 = {
  key: 1,
  class: "flex items-center justify-center h-full"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-600 text-2xl text-center" }, "No se encontraron estacionamientos asociados a este usuario.", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "ml-2 h-full w-1/2" }
const _hoisted_7 = {
  key: 1,
  class: "flex items-center justify-center h-full"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-600 text-2xl text-center" }, "No se encontraron bodegas asociadas a este usuario.", -1)
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableComponent = _resolveComponent("TableComponent")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    title: `Formulario `,
    onOnClose: _ctx.closeModal,
    visible: _ctx.showModal,
    "onUpdate:visible": _cache[0] || (_cache[0] = (e) => _ctx.showModal = e)
  }, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.item.parkingSpots.length > 0)
            ? (_openBlock(), _createBlock(_component_TableComponent, {
                key: 0,
                title: 'Estacionamientos',
                items: _ctx.item.parkingSpots ?? [],
                columns: _ctx.columns,
                buttons: [],
                showButtons: _ctx.showButtons,
                isSelectPage: false
              }, null, 8, ["items", "columns", "showButtons"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.item.warehouses.length > 0)
            ? (_openBlock(), _createBlock(_component_TableComponent, {
                key: 0,
                title: 'Almacenes',
                items: _ctx.item.warehouses ?? [],
                columns: _ctx.columns,
                buttons: [],
                showButtons: _ctx.showButtons,
                isSelectPage: false
              }, null, 8, ["items", "columns", "showButtons"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
        ])
      ])
    ]),
    _: 1
  }, 8, ["onOnClose", "visible"]))
}